import { ASSETS, LINKS } from "@/lib/brand";
import { Instagram, Linkedin } from "lucide-react";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-ivory">
      <div className="container-edit grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-start">
        <div className="md:col-span-5 relative" data-testid="about-portrait-wrap">
          <img
            src={ASSETS.aboutPortrait}
            alt="Stefanie Winstan editorial portrait"
            className="w-full h-[520px] md:h-[680px] object-cover border border-charcoal/10"
            data-testid="about-portrait-img"
          />
        </div>
        <div className="md:col-span-7">
          <div className="overline mb-5">— 01 / The Person</div>
          <h2 className="font-serif-heading text-4xl md:text-6xl text-charcoal leading-[1] mb-8" data-testid="about-title">
            A multi-hyphenate<br />
            <span className="italic text-bronze-deep">building a life in public.</span>
          </h2>
          <div className="space-y-5 text-ink text-base md:text-lg leading-relaxed max-w-xl">
            <p>
              I'm Stefanie — co-founder and CFO of <span className="text-charcoal font-medium">Primo Group</span>,
              an Ottawa-based real estate team. By day I help families buy, sell
              and invest across Ottawa &amp; surrounding areas. By night I create
              lifestyle content, model, and work with brands as on-camera talent.
            </p>
            <p>
              This page is the one link that ties it all together — my listings,
              my content, my storefront, and the easiest way to get in touch.
            </p>
          </div>

          <div className="mt-10 flex items-center gap-4" data-testid="about-socials">
            <a
              href={LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-instagram"
              className="inline-flex items-center gap-2 border border-charcoal px-5 py-3 text-[11px] uppercase tracking-[0.22em] hover:bg-charcoal hover:text-ivory transition-colors"
            >
              <Instagram size={14} strokeWidth={1.5} /> Instagram
            </a>
            <a
              href={LINKS.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-linkedin"
              className="inline-flex items-center gap-2 border border-charcoal px-5 py-3 text-[11px] uppercase tracking-[0.22em] hover:bg-charcoal hover:text-ivory transition-colors"
            >
              <Linkedin size={14} strokeWidth={1.5} /> LinkedIn
            </a>
          </div>

          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-6 border-t border-charcoal/10 pt-8">
            {[
              ["Realty", "Primo Group"],
              ["Location", "Ottawa, ON"],
              ["Focus", "Residential"],
              ["Talent", "On-Camera / UGC"],
            ].map(([k, v]) => (
              <div key={k}>
                <div className="overline">{k}</div>
                <div className="font-serif-heading text-xl text-charcoal mt-1">{v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
